import { PropsWithChildren, createContext, useContext, useRef } from 'react';

import { ObjUtils } from '../utils';

const PropsBridgeContext = createContext<Record<string, unknown> | undefined>(
  undefined,
);

export const PropsBridgeProvider = <T extends Record<string, unknown>>({
  children,
  ...props
}: PropsWithChildren<T>) => {
  const ref = useRef<T>(props as T);
  if (!ObjUtils.isShallowEqual(ref.current, props as T)) {
    ref.current = props as T;
  }

  return (
    <PropsBridgeContext.Provider value={ref.current}>
      {children}
    </PropsBridgeContext.Provider>
  );
};

export function usePropsBridge<
  T extends Record<string, unknown> = Record<string, unknown>,
>() {
  const context = useContext(PropsBridgeContext) as T | undefined;
  if (!context) {
    throw new Error('usePropsBridge must be used within a PropsBridgeProvider');
  }

  return context;
}

export function useOptionalPropsBridge<
  T extends Record<string, unknown> = Record<string, unknown>,
>(): T | undefined {
  return useContext(PropsBridgeContext) as T | undefined;
}
